import { css } from '@emotion/react'
import { useState } from 'react'

import modalService from '~/@common/services/modal.service'
import { Icon } from '~/@common/ui/Icon/Icon'
import WeeklyCalendar from '~/@common/ui/WeeklyCalendar/WeeklyCalendar'

type Props = {
  initialWeekStart: Date | null
  onConfirm: (startDate: Date) => void
}

const WeeklyCalendarModal = ({ initialWeekStart, onConfirm }: Props) => {
  const [pendingWeekStart, setPendingWeekStart] = useState<Date | null>(initialWeekStart)

  return (
    <div css={S}>
      <div className="calendar-modal-header">
        <span>날짜 선택</span>
        <button type="button" aria-label="날짜 선택 닫기" onClick={() => modalService.closeModal()}>
          <Icon name="icon_close" size={24} color="var(--Colors-Gray-900)" />
        </button>
      </div>
      <div className="calendar-modal-body">
        <WeeklyCalendar
          selectedWeekStart={pendingWeekStart}
          onWeekSelect={(startDate) => setPendingWeekStart(startDate)}
          maxDate={new Date()}
        />
        <button
          type="button"
          className="calendar-modal-confirm"
          disabled={pendingWeekStart === null}
          onClick={() => {
            if (!pendingWeekStart) return
            onConfirm(pendingWeekStart)
            modalService.closeModal()
          }}
        >
          선택하기
        </button>
      </div>
    </div>
  )
}

export default WeeklyCalendarModal

const S = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: var(--White);
  border-radius: 14px;
  overflow: hidden;

  .calendar-modal-header {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 64px;
    width: 100%;
    position: relative;

    span {
      font-size: 16px;
      font-weight: 700;
      color: var(--Colors-Gray-900);
    }

    button {
      position: absolute;
      right: 20px;
      background: none;
      border: none;
      cursor: pointer;
      display: flex;
      align-items: center;
      padding: 0;
    }
  }

  .calendar-modal-body {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 14px;
    width: 100%;
  }

  .calendar-modal-confirm {
    width: 100%;
    height: 36px;
    background: var(--Colors-Gray-900);
    color: var(--White);
    border: none;
    border-radius: 10px;
    font-size: 12px;
    font-weight: 700;
    cursor: pointer;

    &:disabled {
      opacity: 0.5;
      cursor: default;
    }
  }
`
